export default function EndOfList() {
  return (
    <div className='text-[#6A6E6E] text-13 leading-[150%] flex gap-3 items-center w-full'>
      <div aria-hidden='true' className='flex flex-1 h-[1px] bg-gradient-to-l from-[#DAE9E9] to-transparent'></div>
      <div>End of list</div>
      <div aria-hidden='true' className='flex flex-1 h-[1px] bg-gradient-to-r from-[#DAE9E9] to-transparent'></div>
    </div>
  )
}
